import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';

import type { ReportAdapter } from '@app/modules/assets/models/reports.model';
import { REPORTS_PATH } from '@app/shared/constants/api-route.config';
import { WithAuditService } from '@app/shared/services/mixins/audit.service';
import { WithCrudService } from '@app/shared/services/mixins/crud.service';
import { WithExportableService } from '@app/shared/services/mixins/export.service';
import { WithJobService } from '@app/shared/services/mixins/job.service';
import { WithLineageService } from '@app/shared/services/mixins/lineage.service';
import { WithLogService } from '@app/shared/services/mixins/log.service';
import { WithCrudVersionService } from '@app/shared/services/mixins/version.service';
import { WithWorkflowableService } from '@app/shared/services/mixins/workflow.service';
import { RestService } from '@app/shared/services/rest.service';

@Injectable({
    providedIn: 'root',
})
export class ReportsService extends classes(
    WithCrudVersionService<ReportAdapter>,
    WithCrudService<ReportAdapter>,
    WithAuditService,
    WithWorkflowableService,
    WithLineageService,
    WithLogService,
    WithExportableService,
    WithJobService,
) {
    protected endpoint = REPORTS_PATH;

    protected readonly api = inject(RestService);
}
